import { render, staticRenderFns } from "./IconCheckboxes.vue?vue&type=template&id=5ab006a6&scoped=true&"
import script from "./IconCheckboxes.vue?vue&type=script&lang=js&"
export * from "./IconCheckboxes.vue?vue&type=script&lang=js&"
import style0 from "./IconCheckboxes.vue?vue&type=style&index=0&id=5ab006a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab006a6",
  null
  
)

export default component.exports